import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.undefind');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-undefind',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.undefind/view.scss */
/* src/app/component.undefind/view.scss: no such file or directory */`],
})
export class ComponentUndefindComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default ComponentUndefindComponent;